import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetTextAutomationsByStage,
    GetTextAutomationsByStage_textAutomations as TextAutomation,
} from 'nutshell-graphql-types';

import GET_TEXT_AUTOMATIONS_FOR_STAGE from '../queries/get-text-automations-for-stage.graphql';

export const useGetTextAutomationsForStage = (
    stageId: string
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    textAutomations: TextAutomation[];
} => {
    const {loading, data, error} = useQuery<GetTextAutomationsByStage, Record<any, any>>(
        GET_TEXT_AUTOMATIONS_FOR_STAGE,
        {
            fetchPolicy: 'cache-and-network',
            variables: {stageId},
            notifyOnNetworkStatusChange: true,
        }
    );

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        textAutomations: data && data.textAutomations ? data.textAutomations : [],
    };
};
